import React from "react";
import { useCartContext } from "~hooks";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const DiscountProgressBar = () => {
  const { numberOfItemsInCart } = useCartContext();

  const NUMBER_OF_LEVELS = 3;
  const currentLevel = Math.min(numberOfItemsInCart, NUMBER_OF_LEVELS);

  const percentage = (currentLevel / NUMBER_OF_LEVELS) * 100;
  const percentageMax100 = Math.min(percentage, 100);

  return (
    <>
      <div className={styles.textContainer}>
        {currentLevel === 1 && (
          <>
            <p className={styles.goal}>
              Add 1 more item to get 10% off total order
            </p>
            <p className={cn(styles.goal, styles.faded)}>
              Add 2 more items to get 15% off total order
            </p>
          </>
        )}

        {currentLevel === 2 && (
          <>
            <p className={styles.goal}>
              <span className={styles.completed}>10% off total order</span>
              {` `}✅
            </p>
            <p className={styles.goal}>
              Add 1 more item to get 15% off total order
            </p>
          </>
        )}

        {currentLevel === 3 && (
          <p className={styles.goal}>
            <span className={styles.completed}>15% off total order</span>
            {` `}✅
          </p>
        )}
      </div>
      <div className={styles.progressContainer}>
        <div
          style={{ width: `${percentageMax100}%` }}
          className={styles.progressBar}
        />
      </div>
    </>
  );
};

export default DiscountProgressBar;
